import React from 'react'
import SectionEstudanteProfissional from '../SectionEstudanteProfissional/SectionEstudanteProfissional'
import SectionResults from '../SectionResults/SectionResults'
import SectionVantagensInstituicao from '../SectionVantagensInstituicao/SectionVantagensInstituicao'
import SectionEnriquecaAulas from '../SectionEnriquecaAulas/SectionEnriquecaAulas'
import SectionCtaBioAtlas from '../SectionCtaBioAtlas/SectionCtaBioAtlas'
import SectionSolucaoBioAtlas from '../SectionSolucaoBioAtlas/SectionSolucaoBioAtlas'
import SectionModulosBioAtlas from '../SectionModulosBioAtlas/SectionModulosBioAtlas'
import SectionCtaCytology from '../SectionCtaCytology/SectionCtaCytology'

const SectionResultsAndEstudante = () => (
  <>
    <SectionResults />
    <SectionEstudanteProfissional />
    <SectionVantagensInstituicao />
    <SectionEnriquecaAulas />
    <SectionCtaBioAtlas />
    <SectionSolucaoBioAtlas />
    <SectionModulosBioAtlas />
    <SectionCtaCytology />
  </>
)

export default SectionResultsAndEstudante
